Ext.define('SA.Frame', {
    singleton: true,

    get({grid, rect}) {
        var rectRegion = Ext.util.Region.from(rect),
            intersectsRect = track => !!rectRegion.intersect(Ext.util.Region.from(Object.assign({}, rect, track))),
            rows = grid.rows.filter(intersectsRect),
            columns = grid.columns.filter(intersectsRect),
            rowIndexes = rows.map(row => row.index),
            columnIndexes = columns.map(column => column.index),
            offset = {top: rows[0].top - 1, left: columns[0].left - 1}, 
            indexes = {rows: rowIndexes, columns: columnIndexes};

        return {offset, indexes};
    }
});